import { Controller } from "@hotwired/stimulus"

// Mantiene end_date = start_date + plan.duration (días calendario), como en el servidor.
export default class extends Controller {
  static targets = ["startDate", "endDate"]
  static values = { durationDays: { type: Number, default: 0 } }

  syncEndDate () {
    if (!this.durationDaysValue || this.durationDaysValue < 0) return
    if (!this.hasStartDateTarget || !this.hasEndDateTarget) return
    const start = this.startDateTarget.value
    if (!start) return
    this.endDateTarget.value = this.addCalendarDays(start, this.durationDaysValue)
  }

  addCalendarDays (isoDateStr, daysToAdd) {
    const [y, m, d] = isoDateStr.split("-").map((n) => parseInt(n, 10))
    if (Number.isNaN(y) || Number.isNaN(m) || Number.isNaN(d)) return ""
    const date = new Date(y, m - 1, d)
    date.setDate(date.getDate() + daysToAdd)
    return [
      date.getFullYear(),
      String(date.getMonth() + 1).padStart(2, "0"),
      String(date.getDate()).padStart(2, "0")
    ].join("-")
  }
}
